// Typelizer digest dc09721cf86ee319dce7f66f1f563523
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/counterparties */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/counterparties', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/counterparties */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/counterparties', {}, options),
    method: 'post',
  }),

  /** GET /c/:company_id/counterparties/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/counterparties/:id', params, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/counterparties/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/counterparties/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /c/:company_id/counterparties/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/counterparties/:id', params, options),
    method: 'delete',
  }),
}
